import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {MigrationParams, MigrationType} from '../model/migration/Migration';

@Injectable({
  providedIn: 'root'
})
export class MigrationService {

  constructor(private http: HttpClient) {
  }

  private static readonly MIGRATION_ID = 'MIGRATION_ID';

  private static readonly CONTEST_MIGRATIONS_URL = `/contests/migrations/${MigrationService.MIGRATION_ID}`;

  executeContestMigration(id: MigrationType, params?: MigrationParams): Observable<unknown> {
    const url = MigrationService.CONTEST_MIGRATIONS_URL.replace(MigrationService.MIGRATION_ID, id);

    return this.http.post(`${environment.api.host}${url}`, params || {});
  }

}
